// `accepted` (WP2.3): both company owners accepted the current version.
export const CONTRACT_STATUSES = ["draft", "active", "accepted", "completed", "cancelled"] as const;
export type ContractStatusValue = (typeof CONTRACT_STATUSES)[number];

/** True for the statuses that have a `b2b:contracts.status.*` label. */
export const isContractStatus = (s: string): s is ContractStatusValue =>
  (CONTRACT_STATUSES as readonly string[]).includes(s);
